<template>
  <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mt-4 d-flex">
    <article class="topic-item">
      <div class="thumbnail">
        <img :src="item.snippet.thumbnails.maxres.url" v-if="item" class="clickable" @click.stop="$router.push({ name: 'TopicDetails', params: { id: item.id } })"/>
        <img class="empty" v-else />
      </div>
      <div class="info p-2">
        <h6 class="typo-h5 mb-1">
          <span class="clickable" @click.stop="$router.push({ name: 'TopicDetails', params: { id: item.id } })" v-if="item">{{item.snippet.title }}</span>
        </h6>
        <p class="content typo-body2 text-grey2 mb-4">
          <template v-if="item">{{item.snippet.description }}</template>
        </p>
        <div class="row justify-content-between mt-auto">
          <div class="col-12 col-xs-12 col-sm-6 col-lg-6 col-xl-6 align-items-center d-flex">
            <span class="video-count flex-v-center">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="mr-1">
                <g>
                  <path
                    d="M18.125 0.621704H4.375C3.68464 0.621704 3.125 1.18135 3.125 1.8717V15.6217C3.125 16.3121 3.68464 16.8717 4.375 16.8717H18.125C18.8154 16.8717 19.375 16.3121 19.375 15.6217V1.8717C19.375 1.18135 18.8154 0.621704 18.125 0.621704Z"
                    stroke="#061325"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.875 19.3717H1.875C1.54348 19.3717 1.22554 19.24 0.991117 19.0056C0.756696 18.7712 0.625 18.4532 0.625 18.1217V3.1217"
                    stroke="#061325"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.125 5.6234V11.8734C8.12501 11.984 8.15437 12.0926 8.21008 12.1882C8.2658 12.2837 8.34587 12.3628 8.44213 12.4173C8.53839 12.4718 8.64739 12.4997 8.75799 12.4983C8.86859 12.4969 8.97683 12.4662 9.07167 12.4092L14.0717 9.28507C14.1642 9.22953 14.2407 9.15098 14.2939 9.05708C14.347 8.96319 14.3749 8.85713 14.3749 8.74923C14.3749 8.64134 14.347 8.53528 14.2939 8.44138C14.2407 8.34748 14.1642 8.26894 14.0717 8.2134L9.07167 5.08923C8.97691 5.03265 8.86887 5.00213 8.75851 5.00078C8.64815 4.99942 8.5394 5.02728 8.44327 5.08152C8.34715 5.13575 8.26708 5.21444 8.21119 5.30961C8.15529 5.40478 8.12556 5.51303 8.125 5.6234Z"
                    stroke="#061325"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
              <span class="count">
                <template v-if="item">{{$tc("generals.video", 2, {count: item.contentDetails.itemCount})}}</template>
              </span>
            </span>
          </div>
          <div class="col-12 col-xs-12 col-sm-6 col-lg-6 col-xl-5 mt-2 mt-sm-0">
            <button
              class="btn btn-primary btn-block btn-sm"
              @click.stop="$router.push({ name: 'TopicDetails', params: { id: item.id } })"
              v-if="item"
            >{{$t("academy.watchThis")}}</button>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: "TopicItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

@import "@/core/themes/partials/_animation.scss";

.topic-item {
  border-radius: 5px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex: 1;
  border: solid 1px $light3;

  >.thumbnail {
    overflow: hidden;
    border-radius: 5px 5px 0 0;
    background: $gradientGrey;
    display: flex;

    img {
      width: 100%;
      // min-height: 290px;
      height: 100%;
    }
  }

  >.info {
    flex: 1;
    display: flex;
    flex-direction: column;

    >.content {
      // max-height: 65px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    >h6:empty {
      height: 20px;
      width: 70%;
      border-radius: 20px;
      @include skeleton("light");
    }
  }

  .video-count {
    & + .btn {
      font-size: 12px;
      line-height: 18px;
      min-width: 120px;
    }

    .count:empty {
      height: 14px;
      border-radius: 14px;
      width: 70px;
      @include skeleton("light");
    }
  }

  img.empty {
    border: none;
    margin: -1px;
    width: calc(100% + 2px);
    height: 290px;
    @include skeleton("light");
  }
}

</style>
